<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.invertersEditedItem.REFERENCE"
                        label="REFERENCE (*)"
                        :rules="[() => !!$store.state.invertersEditedItem.REFERENCE || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-slider
                        v-model="$store.state.invertersEditedItem.EXTENSION_QUANTITY"
                        label="EXTENSION QUANTITY "
                        :tick-labels="extensionQuantityLabels"
                        :max="3"
                        step="1"
                        ticks="always"
                        tick-size="4"
                    ></v-slider>                    
                </v-col>
                <v-col v-if="$store.state.invertersEditedItem.EXTENSION_QUANTITY > 0"
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.invertersEditedItem.EXTENSION_REFERENCE"
                        label="EXTENSION REFERENCE"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.invertersEditedItem.DESC_NL"
                        label="DESC_NL"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.invertersEditedItem.DESC_FR"
                        label="DESC_FR"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.invertersEditedItem.SOG_TYPE"
                        label="SOG_TYPE (*)"
                        :rules="[() => !!$store.state.invertersEditedItem.SOG_TYPE || 'Ce champ est obligatoire !']"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model.number="$store.state.invertersEditedItem.POWER"
                        label="POWER (W) (*)"
                        :rules="[numberInputsMin1Rule]"
                        :error-messages="$store.state.errorMessages"
                        type="number"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model.number="$store.state.invertersEditedItem.STRING_INPUTS"
                        label="STRING_INPUTS (*)"
                        :rules="[numberInputsMin1Rule]"
                        :error-messages="$store.state.errorMessages"
                        type="number"
                        min="0 "
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-radio-group
                        v-model="$store.state.invertersEditedItem.PHASES"                                                column
                    >
                        <v-radio
                            label= "Monophasé"
                            key= 1
                            value= 1
                        ></v-radio>
                        <v-radio
                            label= "Triphasé"
                            key= 3
                            value= 3
                        ></v-radio>
                    </v-radio-group>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.invertersEditedItem.DELTA_COMPATIBLE"
                        label="DELTA_COMPATIBLE"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.invertersEditedItem.EXTENDED"
                        label="EXTENDED"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.invertersEditedItem.STOREDGE"
                        label="STOREDGE"
                    ></v-checkbox>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="3"
                >
                    <v-checkbox
                        v-model="$store.state.invertersEditedItem.EV"
                    label="EV"
                    ></v-checkbox>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireOnduleurs",
		data: function () {
			return {
                extensionQuantityLabels: ["0", "1", "2", "3"],
                numberInputsMin1Rule: val => {
                    if(val < 1) return 'Valeur erronée'
                    return true
                }
            }
        }
    }
</script>
